import type { AxiosRequestConfig } from 'axios';

export const phoneCallProviderRequestConfig = (config: AxiosRequestConfig = {}): AxiosRequestConfig => ({
	...config,
	skipAppAuthenticationHeaders: true,
	skipUnauthorizedLogout: true,
});
